<template>
  <b-container class="pb-5 pt-5 fp_view" id="scannerQuestionnaireContainer">
    <b-row class="pt-5"><div class="title">Questionnaire myfo</div></b-row>
    <b-row class="mt-5">
      <div class="subtitle">
        Bienvenue dans notre questionnaire personnalisé pour nous permettre en quelques clics et seulement quelques secondes de vous proposer la plateforme la plus adaptée à vos besoins !
      </div>
    </b-row>
    <form method="POST" :action="route">
      <b-row id="sqCardQuestions" class="mt-5">
        <div class="p-4" style="width: 100%;">
          <b-progress id="sqProgressbar" :value="currentPage" :max="rows" />
        </div>
        <div class="sqQuestNb">
          Question
          <transition name="fade" mode="out-in">
            <div style="margin-left: 10px" :key="form[currentPage - 1].questionId">
              {{ currentPage }}
            </div>
          </transition>
          /{{ rows }}
        </div>
        <div class="sqQuest mt-5">
          <input type="hidden" name="_token" :value="token" />
          <div v-for="(item, index) in questions" :key="item.id">
            <input type="hidden" :name="'form[' + index + '][questionId]'" :value="item.id" />
            <input type="hidden" :name="'form[' + index + '][answerId]'" :value="form[index].answerId" />
          </div>
          <div v-for="(item, index) in Object.keys(questions)[currentPage - 1]" :key="index">
            <transition name="fade" mode="out-in">
              <div :key="form[currentPage - 1].questionId">
                {{ questions[item].question }}
              </div>
            </transition>
            <div class="sqQuestExplain">
              <p v-if="currentPage == 5">
                (Vous pouvez en sélectionner plusieurs, si vous n'avez aucun de ses titres, veuillez ne rien sélectionner)
              </p>
            </div>
            <transition name="fade" mode="out-in">
              <b-row class="sqDivAnswers mt-5" :key="form[currentPage - 1].questionId">
                <b-col cols="4" v-for="(o, i) in questions[item].answers" :key="i">
                  <div class="sqBtnAnswer" v-on:click="selectAnswer(o.id, currentPage - 1)" :class="o.id == form[currentPage - 1].answerId ? 'selected' : null">
                    {{ o.answer }}
                  </div>
                </b-col>
              </b-row>
            </transition>
          </div>
        </div>
        <!--<b-pagination :disabled="form[currentPage - 1].answerId ? false : true" class="mt-4" limit="1" prev-class="sqFirst" next-class="sqFirst" id="sqPagination" align="fill" first-text="First" prev-text="Question précédente" next-text="Question suivante" last-text="Last" v-model="currentPage" :total-rows="rows" :per-page="perPage" hide-goto-end-buttons aria-controls="my-table"></b-pagination>-->
        <transition name="fade" mode="out-in" :key="form[currentPage - 1].questionId">
          <div
            v-if="currentPage == rows"
            style="width: 100%;
    					text-align: center;"
          >
            <b-button id="sqBtnValidation" class="mt-4 mb-3" type="submit">Valider mes réponses</b-button>
          </div>
        </transition>
      </b-row>
    </form>
  </b-container>
</template>
<script>
import TitleBig from "../firstPortfolio/components/TitleBig.vue";

export default {
  props: ["next_questions", "token", "route"],
  components: {
    TitleBig,
  },
  data() {
    return {
      perPage: 1,
      currentPage: 1,
      questions: this.next_questions,
      form: [],
    };
  },
  computed: {
    rows() {
      return this.questions.length;
    },
  },
  created() {
    let obj = {
      questionId: null,
      answerId: null,
    };
    for (let i = 0; i < this.questions.length; i++) {
      this.form.push({ ...obj, questionId: this.questions[i].id });
    }
  },
  watch: {
    currentPage() {
      if (this.form[this.currentPage - 1].answerId) {
        this.currentPage += 1;
      }
    },
  },
  methods: {
    test() {
      console.log("test");
    },
    selectAnswer(id, i) {
      this.form[i].answerId = id;
      if (this.currentPage < this.rows) {
        setTimeout(() => {
          this.currentPage += 1;
        }, 1000);
      }
    },
  },
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

#scannerQuestionnaireContainer {
  .fade-enter-active {
    transition: all 0.3s ease;
  }
  .fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .fade-enter, .fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
    opacity: 0;
  }
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
    margin: auto;
  }
  .subtitle {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_subtitle Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  #sqCardQuestions {
    background: $bg_color_bl 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    padding: 20px;
    justify-content: center;
    #sqProgressbar {
      background: #707070;
      .progress-bar {
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        color: $mf_ft_color_white;
        text-align: center;
        white-space: nowrap;
        background-color: $purple_color;
        transition: width 0.6s ease;
      }
    }
    .sqQuestNb {
      text-align: center;
      font: normal normal normal $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sqQuestExplain {
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
      width: 100%;
    }
    .sqQuest {
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      min-height: 20vh;
      opacity: 1;
    }
    .sqDivAnswers {
      justify-content: center;
      width: 100%;
      .sqBtnAnswer {
        background: #333436 0% 0% no-repeat padding-box;
        border-radius: 33px;
        opacity: 1;
        border: none;
        margin: 20px;
        align-self: center;
        text-align: center;
        width: 100%;
        color: $mf_ft_color_white;
        padding: 15px;
        &:hover {
          cursor: pointer;
          background: $purple_color;
        }
      }
      .selected {
        background: $purple_color;
      }
    }
    #sqPagination {
      justify-content: space-between;
      height: 50px;
      background: $bg_color_bl;
      border-bottom-left-radius: 33px;
      border-bottom-right-radius: 33px;
      align-items: center;
      width: 100%;

      .page-link {
        margin: 5px;
        background-color: transparent !important;
        border: none;
      }
      .page-item.active {
        display: none !important;
      }

      .page-item.disabled .page-link {
        pointer-events: none;
        background-color: transparent !important;
        color: #414141;
      }

      .page-item.active .page-link {
        font-weight: bold;
        background-color: $bg_color_bl !important;
        border-radius: 33px;
        color: $vstr_grey_color !important;
      }

      .sqFirst {
        text-align: center;
        font: normal normal normal $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #414141;
        opacity: 1;
      }

      li {
        button {
          border: none;
          color: $lt_grey_color;
          background: transparent !important;

          &:hover {
            background-color: transparent;
          }
          &:focus {
            border: none;
            box-shadow: none;
          }
          &:active {
            box-shadow: none;
            border: none;
          }
        }
      }
    }
    #sqBtnValidation {
      text-align: center;
      font: normal normal 600 $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      background: #9561e2 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 41px;
      opacity: 1;
      border: none;
      width: 50%;
    }
  }
}

.select_row_align {
  align-items: center;
}

hr {
  color: $vlt_grey_color !important;
  height: 2px !important;
  margin-top: 4vh !important;
  margin-bottom: 4vh !important;
  padding: 2px;
}

// =====TABLE FP======
thead {
  // background: $bg_color;
  color: $lt_grey_color;
  border-top-left-radius: 33px;
  border-top-right-radius: 33px;
}

.tbHeader {
  display: flex;
  justify-content: center;
  align-items: center;

  .tbHeader_label {
    margin-right: 10px;
  }
}

.tb_col_etf {
  color: $purple_color;
  font-weight: bold;
}

.tb_col_score {
  color: $str_grey_color;
}

#mf_checkbox-1 {
  color: $purple_color;
  height: 30px;
  width: 30px;
}

.table > :not(:first-child) {
  border-top: none !important;
}

// ===========================
.mf_purple_info {
  font-weight: bold;
  color: $purple_color;
  font-size: 1.5em;
}

.mf_sm_img {
  height: 35vh;
}

.form-select {
  color: $lt_grey_color;
  border: none !important;
  border-radius: 50px !important;
  background-color: $bg_color !important;
  height: 40px;
  width: 100%;
}

option {
  border-radius: 30px !important;
  background-color: $bg_color !important;

  &:hover {
    background-color: #9561e2 !important;
  }
}

.mf_spacing {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mf_bg {
  box-shadow: $boxShadow;
  background-color: $bg_color;
  border-radius: 33px;
  text-align: center;
}

.mf_btn {
  background-color: transparent !important;
}

.mf_icon_purple {
  color: $purple_color !important;
}

.mf_1row {
  text-align: initial;

  .fp_mockup {
    height: 100%;
    width: 100%;
  }
  .mf_fp_col_title {
    align-self: center;

    .mf_title {
      font-weight: bold;
      font-size: 3.5vmin;
    }
    .mf_fp_col_title {
      align-self: center;

      .mf_xtra {
        color: $purple_color;
        display: flex;
        font-size: 2vmin;
        font-weight: bold;
        justify-content: flex-end;
      }

      .mf_subtitle {
        color: #707070;
        font-weight: bold;
        font-size: 2.5vmin;
      }

      .mf_title_text {
        color: $lt_grey_color;
        font-size: 2.5vmin;
      }
    }
  }

  .mf_2row {
    .fp_customRange {
      margin-left: 15px;
    }

    .fp_bloc {
      width: 60%;
      margin: auto;
      width: 60%;
      margin: auto;
      padding: 15px;
      margin-top: 20px;
      margin-bottom: 50px;
      justify-content: center;

      @extend .mf_bg;
      // padding-bottom: 0.5rem;

      .fp_bloc_content {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
      }

      .title_bloc {
        margin-bottom: 10px;
        margin-top: 10px;
        color: $lt_grey_color;
      }
    }

    button {
      box-shadow: $boxShadow;
      background: white;
      color: $purple_color;
      border: none;
      border-radius: 33px;
      width: 50px;
      font-size: 20px;
      font-weight: bold;
    }

    .fp_colImg {
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
  }

  .mf_3row {
    text-align: center;

    .mf_select {
      padding-right: 15px;
      padding-left: 15px;
      color: black !important;

      label {
        color: black !important;
      }
    }
  }

  .mf_5row {
    justify-content: center;
  }
}
/* write SCSS here */
</style>
